import type { AssemblyTaskResponse, AssemblyTaskStatus } from '@proerp/shared';
import { assemblyTechniciansLabel } from '@proerp/shared';
import { Badge } from '@proerp/ui';

/**
 * Vier Werte, bewusst ohne „läuft" (2026-08-25): der Zwischenschritt zwischen
 * „bestätigt" und „abgeschlossen" brachte keine Entscheidung mit sich, nur
 * Pflegeaufwand. „Bestätigt" statt des früheren „Terminiert" — das Alt-System
 * (base44) nannte diesen Stand bereits so.
 */
export const TASK_STATUS: Record<
  AssemblyTaskStatus,
  { label: string; tone: 'neutral' | 'info' | 'accent' | 'success' | 'danger' }
> = {
  PLANNED: { label: 'Geplant', tone: 'neutral' },
  CONFIRMED: { label: 'Bestätigt', tone: 'info' },
  DONE: { label: 'Abgeschlossen', tone: 'success' },
  CANCELLED: { label: 'Abgesagt', tone: 'danger' },
};

export const TASK_STATUS_OPTIONS = (
  Object.entries(TASK_STATUS) as [AssemblyTaskStatus, { label: string }][]
).map(([value, meta]) => ({ value, label: meta.label }));

export function TaskStatusBadge({ status }: { status: AssemblyTaskStatus }) {
  const meta = TASK_STATUS[status];
  return <Badge tone={meta.tone}>{meta.label}</Badge>;
}

/**
 * „Monteure" für die Listen-/Karten-Ansicht: eigene Monteure (HR), der
 * beauftragte Montage-Partner UND externe Firmen (Freitext) — alle drei in
 * einer Zeile. Bewusst NICHT in `assemblyTechniciansLabel` (packages/shared)
 * eingebaut: die wird auch für die Portal-Sicht des Partners selbst genutzt,
 * wo der eigene Firmenname redundant wäre.
 */
export function assemblyCrewLabel(task: AssemblyTaskResponse): string {
  return [assemblyTechniciansLabel(task), task.partnerName ?? '']
    .map((value) => value.trim())
    .filter(Boolean)
    .join(', ');
}
